import { Col, Image, Row } from "antd";
import React, { useEffect } from "react";
import i18n from "../../../../lib/Language";
import check from "../../../../assets/img/icons/check.svg";
import block1 from "../../../../assets/img/block1.svg";
import automatic from "../../../../assets/img/automatic.svg";
import test_check from "../../../../assets/img/test_check.svg";
import fruits from "../../../../assets/img/fruits.svg";
import community from "../../../../assets/img/community.svg";
import ProductItem from "../../../../components/Blockchain";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import ReactPlayer from 'react-player/youtube';

const HealthCareDetail = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="box-style">
      <div className="container-wrapper ">
        <div className="container">
          <div className="flex-column-item-center">
            <h1 style={{ marginBottom: 24 }} className="fz-40 color-red">
              Healthcare Solutions
            </h1>
            <p>{i18n.t("blockchain.blockchain_healthcareDesc")}</p>
          </div>

          <div className="mt-50">
            <h2 className="mb-16">{i18n.t("blockchain.blockchain_healthcareWhyChoose")}</h2>
            <Row gutter={[20, 20]}>
              <Col xs={24} sm={12}>
                <div className="flex-item-center h-100">
                  <div>
                    <div className="mt-16">
                      <Image src={check} alt="" preview={false} />
                      <span className="fz-16">
                        {i18n.t("blockchain.blockchain_healthcareWhyChoose_1")}
                      </span>
                    </div>
                    <div className="mt-16">
                      <Image src={check} alt="" preview={false} />
                      <span className="fz-16">
                        {i18n.t("blockchain.blockchain_healthcareWhyChoose_2")}
                      </span>
                    </div>
                    <div className="mt-16">
                      <Image src={check} alt="" preview={false} />

                      <span className="fz-16">
                        {i18n.t("blockchain.blockchain_healthcareWhyChoose_3")}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                {/* <Image src={block1} preview={false} /> */}
                <div className="video-box">
                  <ReactPlayer
                    url={`https://www.youtube.com/watch?v=ivbolczd2i0`}
                    id="react-player"
                    playing
                    width="100%"
                    height="420px"
                    controls
                  />
                </div>

              </Col>
            </Row>
          </div>

          <div className="mt-50">
           
            <Row gutter={[20, 20]}>
              <Col xs={24} sm={12}>
                <Image src={block1} preview={false} />
              </Col>
              <Col xs={24} sm={12}>
              <h2 className="mb-16">{i18n.t("blockchain.blockchain_healthcarePlatform")}</h2>
                <div className="flex-item-center h-100">
                  <div>
                    <div className="mt-16">
                      <Image src={check} alt="" preview={false} />
                      <span className="fz-16">
                        {i18n.t("blockchain.blockchain_healthcarePlatform_1")}
                      </span>
                    </div>
                    <div className="mt-16">
                      <Image src={check} alt="" preview={false} />
                      <span className="fz-16">
                        {i18n.t("blockchain.blockchain_healthcarePlatform_2")}
                      </span>
                    </div>
                    <div className="mt-16">
                      <Image src={check} alt="" preview={false} />

                      <span className="fz-16">
                        {i18n.t("blockchain.blockchain_healthcarePlatform_3")}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
             
            </Row>
          </div>
        </div>

        <div className="flex-column-item-center">
            <p></p>
            <h1 style={{ marginBottom: 24 }} className="fz-40 color-red">
              Please contact us to demo
            </h1>
            <p>{"Email: sales@novasquare.vn"}</p>
            <p>{"Phone/ Zalo: 0913111576"}</p>
          </div>
      </div>
    </div>
  );
};

export default HealthCareDetail;
